module.exports = __webpack_public_path__ + "img/3d1ad68.png";